/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { KeyboardEvent, useState } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';

import { IAppState } from 'src/store';
import './styles.scss';
import { Icon, View } from '..';
import { useComponentDidMount } from 'src/hooks';

const CustomDropdown: React.FC<Props> = ({ label, items, xPosition = 'right', yPosition = 'bottom' }) => {
  // Use to prevent hidden animation when component mounting
  const [preventAnimation, setPreventAnimation] = useState<boolean>(true);
  const { buttonProps, itemProps, isOpen } = useDropdownMenu(items.length);

  useComponentDidMount(() => {
    setTimeout(() => setPreventAnimation(false), 400);
  });

  const handleKeyPress = (item: DropdownItem) => (event: KeyboardEvent) => {
    if (event.code === 'Enter') {
      item.onClick();
    }
  };

  const ItemsWithProps = () => (
    <React.Fragment>
      {items.map((item, idx) => {
        const isRejectedAction = item.label.toLowerCase() === 'reject';
        return (
          <React.Fragment key={idx}>
            <a
              className={cn('cmp-dropdown__item', {
                'cmp-dropdown__item--active': item.isActive,
                'cmp-dropdown__item--reject': isRejectedAction,
                'my-2': isRejectedAction,
              })}
              onClick={item.onClick}
              onKeyPress={handleKeyPress(item)}
              {...itemProps[idx]}>
              <Icon className="cmp-dropdown__item-icon" name={item.icon} />
              {item.label}
            </a>
            {isRejectedAction && <hr className="my-0" />}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );

  return (
    <View className={cn('cmp-dropdown')}>
      <button className={cn('cmp-dropdown__button-wrap')} {...buttonProps}>
        {label}
      </button>
      <View
        className={cn(
          'cmp-dropdown__menu',
          `cmp-dropdown__menu--x-${xPosition}`,
          `cmp-dropdown__menu--y-${yPosition}`,
          { visible: isOpen, hidden: !isOpen, 'prevent-anim': preventAnimation },
        )}>
        <ItemsWithProps />
      </View>
    </View>
  );
};

export type DropdownItem = {
  label: string;
  onClick: (...args: any[]) => void;
  icon?: string;
  isActive?: boolean;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    label: React.ReactNode;
    items: DropdownItem[];
    xPosition?: 'left' | 'right';
    yPosition?: 'top' | 'bottom';
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CustomDropdown);
